// Cart helper functions for localStorage management

export const getCartFromStorage = () => {
  try {
    const cart = localStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error('Error getting cart from storage:', error);
    return [];
  }
};

export const saveCartToStorage = (cart) => {
  try {
    localStorage.setItem('cart', JSON.stringify(cart));
  } catch (error) {
    console.error('Error saving cart to storage:', error);
  }
};

export const addToCart = (product, quantity = 1) => {
  const cart = getCartFromStorage();
  const existingItemIndex = cart.findIndex(item => item.id === product.id);

  if (existingItemIndex !== -1) {
    // Item already in cart, update quantity
    cart[existingItemIndex].quantity += quantity;
  } else {
    // Add new item to cart
    cart.push({ ...product, quantity });
  }

  saveCartToStorage(cart);
  return cart;
};

export const removeFromCart = (productId) => {
  const cart = getCartFromStorage();
  const updatedCart = cart.filter(item => item.id !== productId);
  saveCartToStorage(updatedCart);
  return updatedCart;
};

export const updateCartItemQuantity = (productId, quantity) => {
  const cart = getCartFromStorage();
  const itemIndex = cart.findIndex(item => item.id === productId);

  if (itemIndex !== -1) {
    if (quantity <= 0) {
      return removeFromCart(productId);
    }
    cart[itemIndex].quantity = quantity;
    saveCartToStorage(cart);
  }

  return cart;
};

export const clearCart = () => {
  localStorage.removeItem('cart');
  return [];
};

export const getCartTotal = (cart) => {
  return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
};

export const getCartItemCount = (cart) => {
  return cart.reduce((count, item) => count + item.quantity, 0);
};

// Wishlist functions
export const getWishlistFromStorage = () => {
  try {
    const wishlist = localStorage.getItem('wishlist');
    return wishlist ? JSON.parse(wishlist) : [];
  } catch (error) {
    console.error('Error getting wishlist from storage:', error);
    return [];
  }
};

export const saveWishlistToStorage = (wishlist) => {
  try {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  } catch (error) {
    console.error('Error saving wishlist to storage:', error);
  }
};

export const toggleWishlist = (product) => {
  const wishlist = getWishlistFromStorage();
  const existingIndex = wishlist.findIndex(item => item.id === product.id);

  if (existingIndex !== -1) {
    wishlist.splice(existingIndex, 1);
  } else {
    wishlist.push(product);
  }

  saveWishlistToStorage(wishlist);
  return wishlist;
};

export const isInWishlist = (productId) => {
  const wishlist = getWishlistFromStorage();
  return wishlist.some(item => item.id === productId);
};


